import { z } from 'zod';

import { shiftSchema } from './Shift.ts';

export const vehicleIntegrationSchema = z.object({
  id: z.number(),
  vehicle_id: z.number(),
  dispatch_provider_name: z.string(),
  dispatch_provider_identifier: z.string().nullable(),
  is_active: z.boolean(),
});

export const vehicleIntegrationShiftSchema = z.object({
  integration: vehicleIntegrationSchema,
  shift: shiftSchema.nullable(),
});

export const activateVehicleIntegrationSchema = z.object({
  integration_id: z.number(),
});

export type VehicleIntegration = z.infer<typeof vehicleIntegrationSchema>;
export type VehicleIntegrationShift = z.infer<typeof vehicleIntegrationShiftSchema>;
export type ActivateVehicleIntegration = z.infer<typeof activateVehicleIntegrationSchema>;
